const RATIO_PATTERN = /^(\d+):(\d+)$/;
const FALLBACK_RATIO = '16 / 9';

/**
 * Convert a project aspect ratio string ("9:16" / "16:9" / "21:9")
 * to a CSS `aspect-ratio` value. Falls back to 16:9 for missing or
 * malformed input so placeholders always have a stable box.
 */
export function cssAspectRatio(ratio: string | undefined | null): string {
  if (!ratio) return FALLBACK_RATIO;
  const match = RATIO_PATTERN.exec(ratio.trim());
  if (!match) return FALLBACK_RATIO;
  const width = Number(match[1]);
  const height = Number(match[2]);
  if (width <= 0 || height <= 0) return FALLBACK_RATIO;
  return `${width} / ${height}`;
}
